export const VIMEO_PROJECTS_LIMIT = 15;
export const VIMEO_MEDIA_LIST_LIMIT = 20;
export const VIMEO_VIDEO_LIST_LIMIT = 20;
